var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _g2, _path8, _path9, _path10, _path11, _path12, _g3, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 93,
    viewBox: "0 0 108 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 71C68.5681 71 82 57.5945 82 41C82 24.4055 68.5089 11 52 11C35.432 11 22 24.4055 22 41C22 57.5945 35.432 71 52 71Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5 23C82.8807 23 84 21.8807 84 20.5C84 19.1193 82.8807 18 81.5 18C80.1193 18 79 19.1193 79 20.5C79 21.8807 80.1193 23 81.5 23Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 23C25.1046 23 26 22.1046 26 21C26 19.8954 25.1046 19 24 19C22.8954 19 22 19.8954 22 21C22 22.1046 22.8954 23 24 23Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 59C19.433 59 21 57.2091 21 55C21 52.7909 19.433 51 17.5 51C15.567 51 14 52.7909 14 55C14 57.2091 15.567 59 17.5 59Z",
    fill: "#EAEEF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_36514_127854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.6637 55.4758H75.4932C75.0595 55.4758 74.6877 55.1987 74.5638 54.8292C73.6653 52.1813 71.6825 51.5348 66.8804 49.6566C66.6016 49.5335 66.5706 49.164 66.8495 49.0101C68.2436 48.3327 67.9958 47.7477 67.9958 43.6836C67.9338 43.622 67.8718 43.5296 67.8409 43.4681C67.531 43.0062 67.3142 42.452 67.2522 41.8978L66.9424 41.7439C66.013 41.9594 66.0749 40.9741 65.8271 39.0652C65.7341 38.2647 65.8581 38.1108 66.1988 37.9876L66.5087 37.5873C64.6808 33.5232 65.6102 30.9677 67.4071 30.044C66.8185 28.7509 66.7875 28.2891 66.7875 28.2891C66.7875 28.2891 70.5982 28.9356 71.8994 28.6585C73.5724 28.3199 76.1129 28.7201 77.0733 30.9061C78.6533 31.5219 79.273 32.5379 79.4279 33.5848C79.6447 35.309 78.6843 37.1871 78.4984 37.926C78.5294 37.9568 78.5294 37.9876 78.5604 38.0184C78.8082 38.1416 78.9012 38.3571 78.8082 39.0344C78.5914 40.851 78.6224 41.9902 77.6929 41.7131L76.8564 43.1602C76.8254 43.3449 76.7945 43.4065 76.7945 43.4988C76.7635 43.7759 76.7635 44.2994 76.7635 47.3167C76.7635 47.6861 76.8564 48.0248 77.0423 48.3019C77.2282 48.6406 77.538 48.8869 77.9098 49.0409H77.9408C80.1095 49.9337 81.6585 50.5187 82.8048 50.9806C85.3453 51.9966 85.779 52.2737 85.9959 53.9671C86.0579 54.7984 85.4692 55.4758 84.6637 55.4758Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4458 37.8938C78.5388 37.432 78.3219 36.8778 78.136 36.4775C78.105 36.4159 78.074 36.3544 78.043 36.262C77.3305 34.8149 75.6885 34.1991 74.1394 34.1375C70.1738 33.922 69.802 34.6917 68.5628 33.5525C68.9345 34.1375 68.9965 35.0304 68.3769 36.1696C67.9741 36.9701 67.1686 37.3088 66.456 37.5551C64.6591 33.491 65.5576 30.9355 67.3545 30.0118C66.7658 28.7187 66.7349 28.2568 66.7349 28.2568C66.7349 28.2568 70.5456 28.9034 71.8468 28.6263C73.5198 28.2876 76.0602 28.6879 77.0207 30.8739C78.6007 31.4897 79.2203 32.5057 79.3752 33.5525C79.6231 35.2767 78.6317 37.1549 78.4458 37.8938Z",
    fill: "url(#paint0_linear_36514_127854)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M83.7104 55.4737C84.6708 53.9958 84.2991 52.6103 82.75 50.9785C85.2905 51.9946 85.7242 52.2717 85.9411 53.9651C86.065 54.7348 85.4454 55.4429 84.6399 55.4429H83.7104V55.4737Z",
    fill: "#9AA2B2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9905 48.3321V49.0403H67.7891V48.1166C68.0059 47.624 67.944 47.6548 67.944 43.683C67.882 43.6214 67.82 43.5291 67.7891 43.4675V43.252C67.975 43.5906 68.2538 43.8985 68.5326 44.1448L71.4139 46.1461C72.0955 46.7003 73.0559 46.7311 73.7375 46.1769L76.4329 43.7754C76.5258 43.683 76.6187 43.6214 76.7117 43.5291C76.6807 43.8062 76.6807 44.3296 76.6807 47.3469C76.7117 47.6856 76.8046 48.0243 76.9905 48.3321Z",
    fill: "url(#paint1_linear_36514_127854)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_36514_127854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.257 48.6095C35.7699 48.5787 35.615 48.3016 35.615 48.3016V45.8385C37.1951 44.5453 38.5272 43.0367 38.899 41.0662C39.8904 40.8507 40.5101 39.9578 40.4171 38.9725C40.3861 38.5415 40.1073 38.1412 40.0763 37.6794C40.0763 37.4639 40.0763 37.2483 40.0763 37.0328C40.0763 36.8789 40.0763 36.7557 40.0453 36.6018C40.0453 36.4478 40.0144 36.2939 40.0144 36.1399C39.9214 35.401 39.7355 34.6313 39.2398 33.7384C38.0006 31.4292 35.553 29.8898 32.7957 29.8898C32.238 29.8898 31.6804 29.9513 31.1537 30.0745C30.1623 30.29 29.2638 30.7211 28.4583 31.3369C28.3034 31.46 28.1485 31.5832 27.9936 31.7063C27.9626 31.7371 27.9316 31.7679 27.8697 31.7987C27.0022 32.5992 26.3206 33.6152 25.9488 34.7544C25.5771 35.8936 25.4841 37.0636 25.639 38.2336C25.639 38.2644 25.639 38.2952 25.639 38.326C25.639 38.3568 25.639 38.3875 25.639 38.4183C25.67 38.6339 25.732 38.6031 25.5771 38.7878C25.5461 38.8494 25.4841 38.911 25.4531 39.0033C25.2672 39.342 25.1123 39.8038 25.3292 40.358C25.701 41.4049 26.4445 41.2509 27.1261 41.8359C27.0951 41.8667 27.0332 41.8975 27.0022 41.8975H26.9712L26.1967 42.1438C21.5495 43.5909 21.0228 48.4863 25.7939 49.3792C25.4531 49.41 25.1433 49.5947 24.9264 49.7487C23.4084 50.9187 22.4479 52.7044 22.2001 54.4594C22.1071 54.9828 22.5409 55.4754 23.0986 55.4754H30.4721C30.627 55.4754 30.7819 55.3523 30.8439 55.1983C31.5255 52.7352 33.0745 51.8731 36.2966 50.58L38.1555 49.8411C38.4653 49.7179 38.8061 49.5947 39.1779 49.4408C39.5187 49.3176 39.4877 48.825 39.1159 48.7327C38.7441 48.6403 38.3723 48.6095 38.0006 48.5787C37.6908 48.6095 37.4429 48.6095 37.257 48.6095ZM27.8077 45.469C27.8077 45.1611 28.0246 44.8224 28.4893 44.453C28.6752 44.6993 28.923 44.9764 29.2019 45.2227C29.4187 45.4074 29.6356 45.5922 29.8835 45.7769C30.0384 45.8693 30.1933 45.9924 30.3482 46.1156C30.3792 46.1464 30.4101 46.1772 30.4411 46.1772C30.4721 46.208 30.5341 46.2387 30.565 46.2695V47.7782C30.5341 47.7474 30.5031 47.7166 30.4721 47.7166C30.3172 47.5935 30.1933 47.4703 30.0693 47.3779C29.8525 47.224 29.6356 47.1008 29.4187 46.9777C29.3258 46.9161 29.2638 46.8853 29.2019 46.8237C28.4893 46.3619 27.8387 45.9309 27.8077 45.469Z",
    fill: "white"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.262 48.6086C37.0142 49.5014 36.7354 50.0556 36.7354 50.0556L28.7422 48.7933L29.2069 46.8228C29.2689 46.8844 29.3618 46.9152 29.4238 46.946C29.6406 47.0691 29.8885 47.2231 30.0744 47.377C30.1983 47.4694 30.3532 47.5617 30.4771 47.7157C30.5081 47.7465 30.5391 47.7773 30.5391 47.7773V46.2686C30.4771 46.2378 30.4462 46.207 30.4152 46.1762C31.7164 46.8228 33.3274 47.1615 35.651 45.8068C35.62 45.8068 35.62 45.8376 35.5891 45.8376V48.3007C35.5891 48.3007 35.7749 48.5778 37.262 48.6086Z",
    fill: "url(#paint2_linear_36514_127854)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0168 36.6013C38.6846 37.0631 37.2595 37.2478 35.8343 37.1247C33.6037 36.9399 31.435 36.0471 29.762 34.5692C29.2043 36.1702 27.8102 37.371 26.2301 38.0791C26.0132 38.1715 25.7964 38.2639 25.5795 38.3254C25.5795 38.2947 25.5795 38.2639 25.5795 38.2639C25.4246 37.0939 25.5175 35.9239 25.8893 34.7847C26.2611 33.6455 26.9427 32.6295 27.8102 31.829C27.8411 31.7982 27.8721 31.7674 27.9341 31.7366C28.089 31.6134 28.2439 31.4903 28.3988 31.3671C29.2043 30.7821 30.1338 30.3511 31.0942 30.1048C31.6518 29.9816 32.1785 29.92 32.7362 29.92C35.4935 29.92 37.9411 31.4595 39.1803 33.7687C39.645 34.6616 39.8619 35.4313 39.9548 36.1394C40.0168 36.2934 40.0168 36.4473 40.0168 36.6013Z",
    fill: "url(#paint3_linear_36514_127854)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5859 44.546C28.7718 44.7923 28.9887 45.0079 29.1746 45.1926C28.9577 45.0079 28.7408 44.7923 28.5859 44.546Z",
    fill: "#3973F4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5039 52.3341C30.9153 53.073 29.7999 53.1038 28.8705 53.073C29.8619 52.1186 29.3042 49.0089 25.8343 49.3783H25.8033C21.0322 48.4855 21.5589 43.59 26.1751 42.1429L26.9497 41.8966C27.0116 41.9274 27.0426 41.9582 27.0736 42.0198C27.4454 42.9742 27.9411 43.7747 28.4677 44.4213C26.5779 45.9915 29.2113 46.4842 30.4815 47.6849C31.5969 48.3315 32.5263 51.0409 31.5039 52.3341Z",
    fill: "url(#paint4_linear_36514_127854)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5542 44.5446C28.5232 44.5138 28.4922 44.4831 28.4922 44.4523C28.4922 44.4523 28.5232 44.5138 28.5542 44.5446Z",
    fill: "#3973F4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_36514_127854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.7864 56.893C72.9413 58.0322 72.0428 59.079 70.8655 59.079H34.5554C33.3781 59.079 32.4797 58.0322 32.6346 56.893C32.9754 54.5223 33.5021 54.0296 37.0339 52.6133L37.9014 52.2747C39.5434 51.6281 41.6811 50.8276 44.5624 49.6268C45.213 49.3497 45.7397 48.8571 46.0185 48.2105C46.1734 47.8718 46.2664 47.4716 46.2664 47.0713V41.6832C46.1734 41.5601 46.0805 41.4677 46.0185 41.3446C45.5538 40.6672 45.244 39.8667 45.151 39.0046L44.6863 38.7891C43.2922 39.1277 43.4161 37.6499 43.0443 34.8173C42.8894 33.6473 43.0753 33.401 43.602 33.2163L44.0357 32.6313C41.3713 26.6274 42.7035 22.8711 45.3369 21.5472C44.5314 19.6383 44.4695 18.9609 44.4695 18.9609C44.4695 18.9609 50.0771 19.8846 51.9979 19.5151C54.4454 19.0225 58.2252 19.6075 59.6193 22.8404C61.9429 23.764 62.8414 25.2111 63.0582 26.8121C63.399 29.3368 61.9429 32.1079 61.6641 33.1855C61.6951 33.247 61.6951 33.2778 61.7261 33.3086C62.0978 33.4934 62.2218 33.8012 62.0978 34.8173C61.757 37.4959 61.85 39.1585 60.4558 38.7891L59.2166 40.9443C59.1546 41.1906 59.1546 41.283 59.1236 41.4677C59.0617 41.868 59.0926 42.6685 59.0926 47.0713C59.0926 47.5947 59.2475 48.1181 59.5264 48.5184C59.8362 48.9802 60.2699 49.3805 60.7966 49.596C60.8276 49.596 60.8276 49.596 60.8586 49.6268C64.0497 50.9507 66.3423 51.8128 68.0153 52.4594C71.826 53.9373 72.4146 54.3991 72.7864 56.893Z",
    fill: "white"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6999 33.1855C61.8238 32.5081 61.514 31.6768 61.2661 31.0918C61.2352 30.9994 61.1732 30.9071 61.1422 30.7839C60.0579 28.6287 57.6723 27.7666 55.3797 27.6434C49.5242 27.3356 48.9975 28.444 47.1696 26.7813C47.7273 27.6434 47.7893 28.9674 46.9218 30.63C46.3022 31.8 45.1249 32.3234 44.1025 32.6621C41.4381 26.6582 42.7703 22.9019 45.4037 21.578C44.5362 19.6383 44.4743 18.9609 44.4743 18.9609C44.4743 18.9609 50.0819 19.8846 52.0027 19.5151C54.4503 19.0225 58.23 19.6075 59.6241 22.8404C61.9477 23.764 62.8462 25.2111 63.0631 26.8121C63.4348 29.306 61.9787 32.0771 61.6999 33.1855Z",
    fill: "url(#paint5_linear_36514_127854)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M69.4955 59.0488C70.9206 56.8936 70.3629 54.8615 68.0703 52.46C71.8191 53.9378 72.4387 54.3997 72.7795 56.8628C72.9344 58.002 72.0359 59.0488 70.8586 59.0488H69.4955Z",
    fill: "#9AA2B2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5625 48.5198V49.5666H46.0547V48.2119C46.2096 47.8733 46.3025 47.473 46.3025 47.0727V41.6847C46.2096 41.5615 46.1167 41.4691 46.0547 41.346V41.0381C46.3335 41.5307 46.7053 41.9925 47.17 42.362L51.4145 45.3178C52.4059 46.1491 53.831 46.1799 54.8534 45.3793L58.819 41.8386C58.9429 41.7154 59.0978 41.5923 59.2217 41.4691C59.1598 41.8694 59.1908 42.6699 59.1908 47.0727C59.1598 47.5962 59.3147 48.0888 59.5625 48.5198Z",
    fill: "url(#paint6_linear_36514_127854)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_36514_127854",
    x: 43.5156,
    y: 17.2891,
    width: 64.4849,
    height: 71.1868,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36514_127854"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36514_127854",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_36514_127854",
    x: 0.1875,
    y: 18.8898,
    width: 62.2388,
    height: 69.5857,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36514_127854"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36514_127854",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_36514_127854",
    x: 10.6172,
    y: 7.96094,
    width: 84.1865,
    height: 84.118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_36514_127854"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_36514_127854",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36514_127854",
    x1: 65.4702,
    y1: 33.0764,
    x2: 79.4173,
    y2: 33.0764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36514_127854",
    x1: 72.3926,
    y1: 49.0755,
    x2: 72.3926,
    y2: 45.8868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E5EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_36514_127854",
    x1: 33.0047,
    y1: 50.0815,
    x2: 33.0047,
    y2: 47.7408,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E5EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_36514_127854",
    x1: 25.5012,
    y1: 34.1237,
    x2: 40.0194,
    y2: 34.1237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_36514_127854",
    x1: 22.4566,
    y1: 47.4898,
    x2: 31.9465,
    y2: 47.4898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_36514_127854",
    x1: 42.6391,
    y1: 26.0747,
    x2: 63.1271,
    y2: 26.0747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_36514_127854",
    x1: 52.8127,
    y1: 49.6186,
    x2: 52.8127,
    y2: 44.9202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E5EC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoUsers);
export default __webpack_public_path__ + "static/media/no-users.01b81367c6df095483b10a5b121f09c3.svg";
export { ForwardRef as ReactComponent };